import {
    CONNECTION_QUALITY_BELOW_THRESHOLD,
    CONNECTION_QUALITY_EXCEEDS_THRESHOLD,
    CONNECTION_QUALITY_PING_RECEIVED,
    DISMISS_CONNECTION_QUALITY_WARNING,
    DISPLAY_CONNECTION_QUALITY_WARNING
} from "../../../LiveSwitch/liveSwitchActionTypes";
import { SharedActions } from "../../../Shared/Redux/Actions/sharedActions";
import { ConnectionQuality } from "../../../Shared/sharedTypes";

const initialState = {
    value: 100,
    consecutiveDrops: 0,
    shouldDisplayWarning: false
} as ConnectionQuality;

export default function connectionQualityReducer(state = initialState, action: SharedActions): ConnectionQuality {
    switch (action.type) {
        case CONNECTION_QUALITY_PING_RECEIVED:
            return {
                ...state,
                value: action.connectionValue,
                consecutiveDrops: action.consecutiveDrops ?? 0
            };

        case CONNECTION_QUALITY_BELOW_THRESHOLD:
            return {
                ...state,
                consecutiveDrops: (action.consecutiveDrops ?? state.consecutiveDrops) + 1,
                shouldDisplayWarning: (action.consecutiveDrops ?? 0) == 2 || state.shouldDisplayWarning
            }

        case CONNECTION_QUALITY_EXCEEDS_THRESHOLD:
            return {
                ...state,
                value: action.connectionValue,
                consecutiveDrops: 0,
                shouldDisplayWarning: false
            }

        case DISMISS_CONNECTION_QUALITY_WARNING:
            return {
                ...state,
                value: action.connectionValue,
                shouldDisplayWarning: false
            }

        case DISPLAY_CONNECTION_QUALITY_WARNING:
            return {
                ...state,
                value: action.connectionValue,
                shouldDisplayWarning: true
            }

        default:
            return state;
    }
}
